// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/Message/Message.css
// module id = 1152
// module chunks = 0